export const countryCodeToFlagEmoji = (countryCode) => {
  return countryCode
    ? String.fromCodePoint(
        ...[...countryCode.toUpperCase()].map(
          (letter) => 0x1f1a5 + letter.charCodeAt()
        )
      )
    : "";
};
